import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setUserPermissions, setPortalSettingInfo } from "../reducers/userPermissions";

export function getUserPermissions(data) {
  return (dispatch) => {
    axiosWrapper.post(`${getBackendUrl()}/permissions/getUserPermissions`, data).then((response) => {
      if (response && response.data.status) {
        dispatch(setUserPermissions(response.data.data));
      }
    });
  };
}
export const getNotificationPreference = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/userSettings/getNotificationPreference`, data);
  return response;
};

export function getPortalSetting() {
  return async (dispatch) => {
    const responseData = await axiosWrapper.get(`${getBackendUrl()}/portal/getPortalSettingsObject`);
    if (responseData.status) {
      dispatch(setPortalSettingInfo(responseData.data.data));
    }
  };
}
export const saveUserSettings = async (data) => {
  const response = axiosWrapper.post(`${getBackendUrl()}/userSettings/saveUserSettings`, data);
  return response;
};
export const getUserSettings = async (data) => {
  const response = axiosWrapper.post(`${getBackendUrl()}/userSettings/getUserSettings`, data);
  return response;
};
export const deleteUserSettings = async (data) => {
  const response = axiosWrapper.post(`${getBackendUrl()}/userSettings/deleteUserSettings`, data);
  return response;
};
